import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { MatSliderChange } from "@angular/material/slider";

@Component({
	selector: 'app-range-input',
	templateUrl: './range-input.component.html',
	styleUrls: ['./range-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RangeInputComponent extends BaseInputComponent implements OnInit {
	@Input() min: number = 0;
	@Input() max: number = 100;
	@Input() step: number = 1;
	@Input() thumbLabel: boolean = true;
	@Input() vertical: boolean = false;
	@Input() tickInterval: number;
	@Input() displayWith: (value: number) => string;
	@Input() showInput: boolean = false;

	@Input() disabledTooltip?: string;

	constructor() {
		super();
	}

	@HostListener('keydown.arrowleft', ['$event'])
	@HostListener('keydown.arrowright', ['$event'])
	@HostListener('keydown.arrowup', ['$event'])
	@HostListener('keydown.arrowdown', ['$event'])
	onArrowKeydown(event: KeyboardEvent): void {
		event.stopPropagation();
	}

	updateSlider(event: any) {
		let value = event.target.value;
		if (value < this.min) value = this.min;
		if (value > this.max) value = this.max;

		this.currentValue = value;
		this.form.get(this.controlName)?.setValue(value);
	}

	onSliderMove(event: MatSliderChange) {
		if (event?.value !== null) {
			this.changeValue(event.value);
		}
	}
}
